import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { SERVER_URL } from '../../../../../Config/config';

const TOKEN_KEY = 'auth_token';
export const checkToken = createAsyncThunk('auth/checkToken', async (_, { rejectWithValue }) => {
  const token = sessionStorage.getItem(TOKEN_KEY);
  if (!token) {
    return rejectWithValue('No token found');
  }
  try {
    const response = await axios.get(`${SERVER_URL}/api/v1/auth/dna-verify-token`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (err) {
    sessionStorage.removeItem(TOKEN_KEY);
    return rejectWithValue(err.response?.data?.error || 'Invalid token');
  }
});

export const sendOtp = createAsyncThunk('auth/sendOtp', async (email, { rejectWithValue }) => {
  try {
    const response = await axios.post(`${SERVER_URL}/api/v1/auth/dna/user-send-otp`, { email });
    return response.data;
  } catch (err) {
    return rejectWithValue(err.response?.data?.error || 'Failed to send OTP');
  }
});

export const verifyOtp = createAsyncThunk('auth/verifyOtp', async ({ email, otp }, { rejectWithValue }) => {
  try {
    const response = await axios.post(`${SERVER_URL}/api/v1/auth/dna/user-verify-otp`, { email, otp });
    console.log('response', response);
    sessionStorage.setItem(TOKEN_KEY, response.data.tokens.accessToken);
    return response.data;
  } catch (err) {
    return rejectWithValue(err.response?.data?.error || 'Failed to verify OTP');
  }
});

export const logout = createAsyncThunk('auth/logout', async (_, { rejectWithValue }) => {
  try {
    await axios.post(`${SERVER_URL}/api/v1/auth/logout`);
    sessionStorage.removeItem(TOKEN_KEY);
    return { message: 'Logged out successfully' };
  } catch (err) {
    return rejectWithValue(err.response?.data?.error || 'Failed to logout');
  }
});

const dnaAuthSlice = createSlice({
  name: 'dnaAuth',
  initialState: {
    isAuthenticated: false,
    email: '',
    otp: '',
    showOtp: false,
    error: '',
    loading: false,
    success: '',
  },
  reducers: {
    setEmail: (state, action) => {
      state.email = action.payload;
      state.error = '';
      state.success = '';
    },
    setOtp: (state, action) => {
      state.otp = action.payload;
      state.error = '';
      state.success = '';
    },
    clearMessages: (state) => {
      state.error = '';
      state.success = '';
    },
  },
  extraReducers: (builder) => {
    builder
      // Check Token
      .addCase(checkToken.fulfilled, (state, action) => {
        state.isAuthenticated = action.payload.isAuthenticated;
      })
      .addCase(checkToken.rejected, (state) => {
        state.isAuthenticated = false;
      })
      // Send OTP
      .addCase(sendOtp.pending, (state) => {
        state.loading = true;
        state.error = '';
        state.success = '';
      })
      .addCase(sendOtp.fulfilled, (state) => {
        state.loading = false;
        state.showOtp = true;
        state.success = 'OTP sent successfully!';
      })
      .addCase(sendOtp.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Verify OTP
      .addCase(verifyOtp.pending, (state) => {
        state.loading = true;
        state.error = '';
        state.success = '';
      })
      .addCase(verifyOtp.fulfilled, (state) => {
        state.loading = false;
        state.isAuthenticated = true;
        state.showOtp = false;
        state.email = '';
        state.otp = '';
        state.success = 'Login successful!';
      })
      .addCase(verifyOtp.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Logout
      .addCase(logout.fulfilled, (state) => {
        state.isAuthenticated = false;
        state.email = '';
        state.otp = '';
        state.showOtp = false;
        state.error = '';
        state.success = '';
      })
      .addCase(logout.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export const { setEmail, setOtp, clearMessages } = dnaAuthSlice.actions;
export default dnaAuthSlice.reducer;